export default __webpack_public_path__ + "static/media/20160909_214748.a235e1db.jpg";